import React from 'react'
import styled from 'styled-components/macro'
import { faLink } from '@fortawesome/pro-light-svg-icons'
import { ButtonLink } from '../../components'
import { AuthenticationContext } from 'contexts'
import { useContext } from 'react'

const businessLinks = [
  {
    title: 'Checklista inför besiktning',
    href: 'https://opus.se/nyheter/checklista-infor-besiktning/',
  },

  {
    title: 'Klimatkompensera för din körning',
    href: 'https://opus.se/klimatkompensera-din-korning/',
  },

  {
    title: 'Vattenfall och Opus i samarbete för minskade klimatavtryck',
    href: 'https://www.vattenfall.se/foretag/elavtal/opus-foretag/',
  },
]

const privateLinks = [
  {
    title: 'Checklista inför besiktning',
    href: 'https://opus.se/nyheter/checklista-infor-besiktning/',
  },

  {
    title: 'Klimatkompensera för din körning',
    href: 'https://opus.se/klimatkompensera-din-korning/',
  },

  {
    title: 'Vattenfall och Opus i samarbete för minskade klimatavtryck',
    href: 'https://opus.se/nyheter/vattenfall-och-opus-i-samarbete-for-minskade-klimatavtryck/',
  },

  {
    title: 'Rabatt på fosilfritt elavtal hos Vattenfall',
    href:
      'https://www.vattenfall.se/elavtal/opus?utm_campaign=vfogswe_2505_opusrabatterbj_priv_newmove&utm_source=referral&utm_medium=mypages',
  },
]

const LinkList = styled.ul`
  padding: 0;
`
const ListItem = styled.li`
  list-style-type: none;
  margin-bottom: 2rem;
`

export function StartPageLinks() {
  const authContext = useContext(AuthenticationContext)
  return (
    <LinkList>
      {authContext.customerType === 'private'
        ? privateLinks.map(({ title, href }, idx) => (
            <ListItem key={idx}>
              <ButtonLink alignLeft className="fullWidth" icon={faLink} target="_blank" to={{ pathname: href }}>
                {title}
              </ButtonLink>
            </ListItem>
          ))
        : businessLinks.map(({ title, href }, idx) => (
            <ListItem key={idx}>
              <ButtonLink alignLeft className="fullWidth" icon={faLink} target="_blank" to={{ pathname: href }}>
                {title}
              </ButtonLink>
            </ListItem>
          ))}
    </LinkList>
  )
}
